import { useUserProfile } from "@/contexts/UserProfileContext";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Eye } from "lucide-react";

export default function DemoFormOverlay({ children }) {
  const { isDemo } = useUserProfile();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user?.isDemo && !isDemo) {
    return children;
  }

  const handleCreateAccount = () => {
    navigate("/");
  };

  return (
    <div className="relative">
      {/* Demo notice banner */}
      <div
        style={{
          background: "#FFF8E1",
          borderBottom: "1px solid #FFE082",
          padding: "12px 16px",
          textAlign: "center",
        }}
        data-testid="demo-form-notice"
      >
        <div className="flex items-center justify-center gap-2 mb-2">
          <Eye size={16} style={{ color: "#F9A01B" }} />
          <span className="text-sm font-semibold" style={{ color: "#E65100" }}>
            Modo demostración
          </span>
        </div>
        <p className="text-xs mb-3" style={{ color: "#795548" }}>
          Estás viendo los datos de ejemplo de José Pérez. Para completar tu propia evaluación:
        </p>
        <button
          onClick={handleCreateAccount}
          className="cursor-pointer active:scale-[0.97] transition-transform"
          style={{
            background: "linear-gradient(135deg,#00628F 0%,#0080A0 50%,#2A9D8F 100%)",
            color: "white",
            border: "none",
            borderRadius: 8,
            padding: "8px 16px",
            fontSize: 12,
            fontWeight: 600,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
          data-testid="demo-form-create-btn"
        >
          <span>Crear mi cuenta para comenzar</span>
          <ArrowRight size={14} />
        </button>
      </div>

      {/* Form content - inputs disabled but navigation works */}
      <div className="demo-mode-container">
        <style>{`
          .demo-mode-container input,
          .demo-mode-container textarea,
          .demo-mode-container select,
          .demo-mode-container [role="checkbox"],
          .demo-mode-container [role="radio"],
          .demo-mode-container .we-pill-option,
          .demo-mode-container .we-check-option {
            pointer-events: none !important;
            opacity: 0.7 !important;
          }
          .demo-mode-container button[data-testid*="submit"],
          .demo-mode-container button[type="submit"] {
            display: none !important;
          }
        `}</style>
        {children}
      </div>
    </div>
  );
}
